import './NewsTabs.scss';
import * as React from 'react';
import classNames from 'classnames';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { formatDate } from '../../utils/dateUtils';
import NewsStatusTag from './NewsStatusTag';

export interface INewsTabsProps {
  className?: string;
  news: INewsListItem[];
  activeNewsItemId?: number | undefined | null;
  onItemClick: (item: INewsListItem) => void;
}

const NewsTabs = ({
  className,
  news,
  activeNewsItemId,
  onItemClick
}: INewsTabsProps) => (
  <div className={className}>
    {news.map(item => (
      <div
        key={item.id}
        onClick={() => onItemClick(item)}
        className={classNames(
          'mb-1 px-4 py-3 cursor-pointer',
          activeNewsItemId === item.id
            ? 'has-background-white z-10 relative'
            : 'has-background-gray-400'
        )}
      >
        <div className="f6 font-semibold uppercase has-text-dark-2 flex items-center">
          {item.publishedAt
            ? formatDate(item.publishedAt, 'do MMMM yyyy')
            : null}
          <NewsStatusTag size="mini" item={item} className="ml-1" />
        </div>
        <p className="f5 font-semibold m-0 has-text-black break-words">
          {item.title}
        </p>
      </div>
    ))}
  </div>
);

export default NewsTabs;

interface INewsTabsContainerProps extends React.PropsWithChildren<{}> {
  className?: string;
}

export const NewsTabsContainer = ({ className, ...props }: INewsTabsContainerProps) => (
  <div
    className={classNames(
      'has-background-light-3 py-4 pl-4 w-96 flex-none relative NewsTabsContainer',
      className,
    )}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/News/NewsTabs.tsx